import { GetShareListRequest } from '@finance-lab/utils/types'
import ApiBase from './Api'

const SHARE_API_PATHS = {
    SHARES: '/shares',
    SHARES_ADMIN: '/admin/shares',
}

class ShareApi extends ApiBase {
    async findAll() {
        const fetchedShares = await this._getRequest(SHARE_API_PATHS.SHARES)

        return fetchedShares
    }
    async findByCompanyId(companyId: string) {
        if (!companyId) {
            return []
        }
        const fetchedShares = await this._getRequest<GetShareListRequest>(SHARE_API_PATHS.SHARES, {
            queryParameters: { companyId },
        })

        return fetchedShares
    }
}

export default ShareApi
